import { useAuth } from "../auth/AuthProvider";

export function Login() {
  const { login } = useAuth();
  return (
    <main className="centre">
      <div className="card login">
        <h1>Ring Swap — QA Review</h1>
        <p className="muted">Sign in with your Aardvark Jewellery account to review generated images.</p>
        <button className="btn primary" onClick={login}>
          Sign in with Google
        </button>
      </div>
    </main>
  );
}
